<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="row p-3" *ngIf="templateNo != 4 && templateNo != 5 && templateNo!=6">
  <div class="col-md-3 text-left p-0">
    <div class="text-blue" *ngIf="(impactAssessmentSummary && (impactAssessmentSummary.length>0))">
      <div>{{endIndex}} out of {{totalCount}}</div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="pull-right" style="right: 20px;">
      <span *ngIf="commonService.checkPlanTypeAction(dCode)">
        <span *ngIf="currentUserRole === 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red" (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
        <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red"
            *ngIf="(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)"
            (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
          <span class="disabled"
            *ngIf="!(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)">
            <span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
      </span>
      <span class="cursor-pointer text-blue pl-3" (click)="bulkUpdate()"
        *ngIf="commonService.checkPlanTypeAction(buCode)">
        Bulk Update
      </span>
      <span class="cursor-pointer text-blue pl-3" *ngIf="commonService.checkPlanTypeAction(erCode)"
        (click)="downloadReport()"><span class="fa fa-download"></span>
        Export Report
      </span>
      <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
          Filters <span class="caret" #dropInput></span>
        </span>
        <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu impact-assessment-filterDropdown p-3"
          role="menu" aria-labelledby="button-triggers-manual" style="width: 100%;">
          <div class="dropdown-filter-part">
            <app-impact-assessment-filter (OnFilter)="OnFilter($event)"></app-impact-assessment-filter>
            <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
          </div>
        </div>
      </span>
      <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="cursor-pointer text-blue">
          <span class="fa fa-cog setting-icon" #dropInputsettings></span>
        </span>
        <div class="row">
          <div class="col-lg-5"></div>
          <div class="col-lg-3">
            <div id="dropdown-triggers-manual" *dropdownMenu
              class="dropdown-menu settings-dropdown-menu p-3  overflow-auto" role="menu"
              aria-labelledby="button-triggers-manual" style="width: 330px;">
              <div class="dropdown-filter-part pt-2">
                <div class="py-1" *ngFor="let item of itemActiveModel">
                  <input type="checkbox"
                    (change)="showHideColumn(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                    [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                  <span class="ml-2">{{ item.itemTitle }}</span>
                </div>
                <button class="fa fa-times cross-button filter-close-button" type="button"
                  (click)="dropInputsettings.click()"></button>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
  <div class="table-responsive box-shadow table-cont" #tableContent>
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
    <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
    <table class="table table-fixed mb-0 policy-table">
      <thead>
        <tr>
          <th class="text-center width-1pr">
            <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event, this.impactAssessmentSummary)" />
          </th>
          <th class="width-3pr text-center" (click)="sortImpactAssessment('updatedDB_Id')">Id
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'updatedDB_Id' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'updatedDB_Id' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.regulator"
            (click)="sortImpactAssessment('Regulator')">Regulator
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Regulator' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Regulator' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentColumns.title"
            (click)="sortImpactAssessment('Title')">Title
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Title' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Title' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentColumns.ruleTopic"
            (click)="sortImpactAssessment('RuleTopic')">Topic
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'RuleTopic' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'RuleTopic' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentColumns.publishDate"
            (click)="sortImpactAssessment('updatedDB_Date')">Publish Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'updatedDB_Date' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'updatedDB_Date' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.ruleType"
            (click)="sortImpactAssessment('RuleType')">Rule Type
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'RuleType' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'RuleType' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.applicationDate"
            (click)="sortImpactAssessment('ApplicationDate')">Effective Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ApplicationDate' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ApplicationDate' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.legalEntity"
            (click)="sortImpactAssessment('LegalEntity')">Legal Entity
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'LegalEntity' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'LegalEntity' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.jurisdiction"
            (click)="sortImpactAssessment('Jurisdiction')">Division
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Jurisdiction' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Jurisdiction' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.impactRating"
            (click)="sortImpactAssessment('ImpactRating')">Impact Rating
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImpactRating' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImpactRating' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.implementationType"
            (click)="sortImpactAssessment('ImplementationType')">Implementation Type
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImplementationType' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImplementationType' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.assessmentTeam && templateNo<2"
            (click)="sortImpactAssessment('AssessmentTeam')">Assessment Team
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'AssessmentTeam' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'AssessmentTeam' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.assessor"
            (click)="sortImpactAssessment('Assessor')">Assessor
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Assessor' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Assessor' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentColumns.reviewTeam && templateNo<2"
            (click)="sortImpactAssessment('ReviewTeam')">Review Team
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ReviewTeam' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ReviewTeam' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentColumns.reviewer && templateNo<2"
            (click)="sortImpactAssessment('Reviewer')">Reviewer
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Reviewer' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Reviewer' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.implementationTeam && templateNo<2"
            (click)="sortImpactAssessment('ImplementationTeam')">Implementation Team
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImplementationTeam' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImplementationTeam' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.implementationOwner && templateNo<2"
            (click)="sortImpactAssessment('ImplementationOwner')">Implementation Owner
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImplementationOwner' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImplementationOwner' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.assessmentStatus"
            (click)="sortImpactAssessment('AssessmentStatus')">Assessment Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'AssessmentStatus' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'AssessmentStatus' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.assessmentDueDate"
            (click)="sortImpactAssessment('AssessmentDueDate')">Next Action Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'AssessmentDueDate' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'AssessmentDueDate' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentColumns.reviewStatus && templateNo<2"
            (click)="sortImpactAssessment('ReviewStatus')">Review Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ReviewStatus' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ReviewStatus' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.reviewDueDate && templateNo<2"
            (click)="sortImpactAssessment('ReviewDueDate')">Review Due Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ReviewDueDate' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ReviewDueDate' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.implementationStatus && templateNo<2"
            (click)="sortImpactAssessment('ImplementationStatus')">Implementation Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImplementationStatus' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImplementationStatus' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentColumns.implementationDueDate && templateNo<2"
            (click)="sortImpactAssessment('ImplementationDueDate')">Implementation Due Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'ImplementationDueDate' && !impactAssessmentFilter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'ImplementationDueDate' && impactAssessmentFilter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="impactAssessmentSummary.length === 0">
        <tr>
          <td>No Data</td>
        </tr>
      </tbody>
      <tbody *ngIf="(impactAssessmentSummary && (impactAssessmentSummary.length > 0))"
        [style.max-height.px]="myInnerHeight">
        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
          (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
          *ngIf="impactAssessmentSummary.length > 0">
          <div *cdkVirtualFor="let item of impactAssessmentSummary; let i = index">
            <tr
              [ngClass]="{'d-highlight': item.id === newIAItemId, 'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
              (click)="selectedItemId = item.id">
              <td class="width-1pr text-center" scope="row">
                <i class="fa fa-square-o icon-font" (click)="selectItem('Checked', item.id, item.updatedDBId)"
                  *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectItem('UnChecked', item.id, item.updatedDBId)"
                  *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
              </td>
              <td class="width-3pr text-center tabel-td-scroll" scope="row">
                <span *ngIf="item.isMerged">
                  <a (click)="redirectLink(templateNo,item.id)">
                    <div *ngFor="let option of item.merged_Id|stringToArrayParent;">{{option}}</div>
                  </a>
                </span>
                <span *ngIf="!item.isMerged">
                  <a (click)="redirectLink(templateNo,item.id)">{{item.updatedDBId}}</a>
                </span>

              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.regulator" scope="row">
                {{item.regulator}}</td>
              <td class="width-8pr tabel-td-scroll" *ngIf="impactAssessmentColumns.title" scope="row">{{item.title}}
              </td>
              <td class="width-8pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.ruleTopic" scope="row">
                <!-- <span *ngFor="let ruleItem of item.ruleTopic|jsonStringToArray; let j = index">
                  <span *ngIf="j>0 && ruleItem[1]!=''">,</span>
                  {{ruleItem[1]}}
                </span> -->
                {{item.ruleTopic}}
              </td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.publishDate" scope="row">
                {{item.publishDate | date:'dd-MMM-yyyy'}}
              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.ruleType" scope="row">
                {{item.ruleType}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.applicationDate"
                scope="row">{{item.applicationDate |
                date:'dd-MMM-yyyy'}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.legalEntity" scope="row">
                {{item.legalEntity}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.jurisdiction"
                scope="row">{{item.jurisdiction}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.impactRating"
                scope="row">{{item.impactRating}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.implementationType"
                scope="row">{{item.implementationType}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.assessmentTeam && templateNo<2"
                scope="row">{{item.assessmentTeam}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.assessor" scope="row">
                {{item.assessor}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.reviewTeam && templateNo<2" scope="row">
                {{item.reviewTeam}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.reviewer && templateNo<2" scope="row">
                {{item.reviewer}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.implementationTeam && templateNo<2"
                scope="row">{{item.implementationTeam}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.implementationOwner && templateNo<2"
                scope="row">{{item.implementationOwner}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.assessmentStatus"
                scope="row">{{item.assessmentStatus}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.assessmentDueDate"
                scope="row">{{item.assessmentDueDate |
                date:'dd-MMM-yyyy'}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.reviewStatus && templateNo<2"
                scope="row">{{item.reviewStatus}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.reviewDueDate && templateNo<2"
                scope="row">{{item.reviewDueDate |
                date:'dd-MMM-yyyy'}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.implementationStatus && templateNo<2"
                scope="row">{{item.implementationStatus}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentColumns.implementationDueDate && templateNo<2"
                scope="row">{{item.implementationDueDate |
                date:'dd-MMM-yyyy'}}</td>
              <td class="width-3pr text-center tabel-td-scroll">
                <a [routerLink]="['/impact-assessment/details/impact/', item.id]">View</a> |
                <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                  <a (click)="duplicateImpactAssessment(item.id)">Copy</a>
                </span>
                <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                  <span *ngIf="checkIAUserAuth(item)">
                    <a (click)="duplicateImpactAssessment(item.id)">Copy</a>
                  </span>
                  <span class="disabled" *ngIf="!checkIAUserAuth(item)">Copy</span>
                </span>
              </td>
            </tr>
          </div>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>

<!----------------------------- Template 6 Design ---------------------------------------->
<div class="row p-3" *ngIf="templateNo==6">
  <div class="col-md-3 text-left p-0">
    <div class="text-blue" *ngIf="(impactAssessmentT6Summary && (impactAssessmentT6Summary.length>0))">
      <div>{{endIndex}} out of {{totalCount}}</div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="pull-right" style="right: 20px;">
      <span *ngIf="commonService.checkPlanTypeAction(dCode)">
        <span *ngIf="currentUserRole === 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red" (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
        <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red"
            *ngIf="(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)"
            (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
          <span class="disabled"
            *ngIf="!(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)">
            <span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
      </span>
      <!-- <span class="cursor-pointer text-blue pl-3" (click)="bulkUpdate()"
        *ngIf="commonService.checkPlanTypeAction(buCode)">
        Bulk Update
      </span> -->
      <span class="cursor-pointer text-blue pl-3" *ngIf="commonService.checkPlanTypeAction(erCode)"
        (click)="downloadReport()"><span class="fa fa-download"></span>
        Export Report
      </span>
      <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
          Filters <span class="caret" #dropInput></span>
        </span>
        <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu impact-assessment-filterDropdown p-3"
          role="menu" aria-labelledby="button-triggers-manual" style="width: 100%;">
          <div class="dropdown-filter-part template6-dropdown-filter">
            <app-impact-assessment-t6-filter (OnFilterT6)="OnFilterT6($event)"></app-impact-assessment-t6-filter>
            <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
          </div>
        </div>
      </span>
      <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="cursor-pointer text-blue">
          <span class="fa fa-cog setting-icon" #dropInputsettings></span>
        </span>
        <div class="row">
          <div class="col-lg-5"></div>
          <div class="col-lg-3">
            <div id="dropdown-triggers-manual" *dropdownMenu
              class="dropdown-menu  settings-dropdown-menu p-3 overflow-auto" role="menu"
              aria-labelledby="button-triggers-manual" style="width: 330px;">
              <div class="dropdown-filter-part pt-2">
                <div class="py-1" *ngFor="let item of itemActiveT6Model">
                  <input type="checkbox"
                    (change)="showHideColumnT6(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                    [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                  <span class="ml-2">{{ item.itemTitle }}</span>
                </div>
                <button class="fa fa-times cross-button filter-close-button" type="button"
                  (click)="dropInputsettings.click()"></button>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
  <div class="table-responsive box-shadow table-cont" #tableContent>
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
    <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
    <table class="table table-fixed mb-0 policy-table">
      <thead>
        <tr>
          <th class="text-center width-1pr">
            <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event, this.impactAssessmentT6Summary)" />
          </th>
          <th class="width-3pr text-center" (click)="sortImpactAssessment('updatedDB_Id')">Id
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'updatedDB_Id' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'updatedDB_Id' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT6Columns.regulator"
            (click)="sortImpactAssessment('Regulator')">Regulator
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'Regulator' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'Regulator' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT6Columns.title"
            (click)="sortImpactAssessment('Title')">Title
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'Title' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'Title' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT6Columns.ruleTopic"
            (click)="sortImpactAssessment('RuleTopic')">Topic
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'RuleTopic' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'RuleTopic' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT6Columns.ruleType"
            (click)="sortImpactAssessment('RuleType')">Rule Type
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'RuleType' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'RuleType' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT6Columns.publishDate"
            (click)="sortImpactAssessment('updatedDB_Date')">Publish Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'updatedDB_Date' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'updatedDB_Date' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT6Columns.applicationDate"
            (click)="sortImpactAssessment('ApplicationDate')">Effective Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'ApplicationDate' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'ApplicationDate' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          
          
          <th class="width-3pr text-center" *ngIf="impactAssessmentT6Columns.impactRating"
            (click)="sortImpactAssessment('ImpactRating')">Impact Rating
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'ImpactRating' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'ImpactRating' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          
          <th class="width-3pr text-center" *ngIf="impactAssessmentT6Columns.assessor"
            (click)="sortImpactAssessment('Assessor')">Assessor
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'Assessor' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'Assessor' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
         
          <th class="width-5pr text-center" *ngIf="impactAssessmentT6Columns.assessmentStatus"
            (click)="sortImpactAssessment('AssessmentStatus')">Assessment Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'AssessmentStatus' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'AssessmentStatus' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT6Columns.assessmentDueDate"
            (click)="sortImpactAssessment('AssessmentDueDate')">Next Action Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT6Filter.SortKey === 'AssessmentDueDate' && !impactAssessmentT6Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT6Filter.SortKey === 'AssessmentDueDate' && impactAssessmentT6Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          
        
          <th class="width-3pr text-center">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="impactAssessmentT6Summary.length === 0">
        <tr>
          <td>No Data</td>
        </tr>
      </tbody>
      <tbody *ngIf="(impactAssessmentT6Summary && (impactAssessmentT6Summary.length > 0))"
        [style.max-height.px]="myInnerHeight" >
        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
          (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
          *ngIf="impactAssessmentT6Summary.length > 0">
          <div *cdkVirtualFor="let item of impactAssessmentT6Summary; let i = index">
            <tr
            (dblclick)="redirectLink(templateNo,item.id)"
              [ngClass]="{'d-highlight': item.id === newIAItemId, 'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
              (click)="selectedItemId = item.id">
              <td class="width-1pr text-center" scope="row">
                <i class="fa fa-square-o icon-font" (click)="selectItem('Checked', item.id, item.updatedDB_Id
                )"
                  *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectItem('UnChecked', item.id, item.updatedDB_Id
                )"
                  *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
              </td>
              <td class="width-3pr text-center tabel-td-scroll" scope="row">
                <span *ngIf="item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">
                    <div *ngFor="let option of item.merged_Id|stringToArrayParent;">{{option}}</div>
                  </a>
                </span>
                <span *ngIf="!item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">{{item.updatedDB_Id
                  }}</a>
                </span>

              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.regulator" scope="row">
                {{item.regulator}}</td>
              <td class="width-8pr tabel-td-scroll" *ngIf="impactAssessmentT6Columns.title" scope="row">{{item.title}}
              </td>
              <td class="width-8pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.ruleTopic" scope="row">
                <!-- <span *ngFor="let ruleItem of item.ruleTopic|jsonStringToArray; let j = index">
                  <span *ngIf="j>0 && ruleItem[1]!=''">,</span>
                  {{ruleItem[1]}}
                </span> -->
                {{item.ruleTopic}}
              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.ruleType" scope="row">
                {{item.ruleType}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.publishDate" scope="row">
                {{item.updatedDB_Date | date:'dd-MMM-yyyy'}}
              </td>
             
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.applicationDate"
                scope="row">{{item.applicationDate |
                date:'dd-MMM-yyyy'}}</td>
                <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.impactRating"
                scope="row">{{item.impactRating}}</td>
              
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.assessor"
                scope="row">{{item.assessor}}</td>

                <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.assessmentStatus"
                scope="row">{{item.currentAssessmentStatus}}</td>

                <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT6Columns.assessmentDueDate"
                scope="row">{{item.assessmentDueDate |
                date:'dd-MMM-yyyy'}}</td>



              
              <td class="width-3pr text-center tabel-td-scroll">
                <a [routerLink]="['/impact-assessment/details/impact/',templateNo, item.id]">View</a> |
                <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                  <a (click)="duplicateImpactAssessmentT6(item.id)">Copy</a>
                </span>
                <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                  <span *ngIf="checkIAUserAuth(item)">
                    <a (click)="duplicateImpactAssessmentT6(item.id)">Copy</a>
                  </span>
                  <span class="disabled" *ngIf="!checkIAUserAuth(item)">Copy</span>
                </span>
              </td>
            </tr>
          </div>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>

<!-- Template 4 Design -->

<div class="row p-3" *ngIf="templateNo == 4">
  <div class="col-md-3 text-left p-0">
    <div class="text-blue" *ngIf="(impactAssessmentT4Summary && (impactAssessmentT4Summary.length>0))">
      <div>{{endIndex}} out of {{totalCount}}</div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="pull-right" style="right: 20px;">
      <span *ngIf="commonService.checkPlanTypeAction(dCode)">
        <span *ngIf="currentUserRole === 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red" (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
        <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red"
            *ngIf="(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)"
            (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
          <span class="disabled"
            *ngIf="!(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)">
            <span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
      </span>
      <span class="cursor-pointer text-blue pl-3" (click)="bulkUpdate()"
        *ngIf="commonService.checkPlanTypeAction(buCode)">
        Bulk Update
      </span>
      <span class="cursor-pointer text-blue pl-3" *ngIf="commonService.checkPlanTypeAction(erCode)"
        (click)="downloadReportT4()"><span class="fa fa-download"></span>
        Export Report
      </span>
      <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
          Filters <span class="caret" #dropInput></span>
        </span>
        <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu impact-assessment-filterDropdown p-3"
          role="menu" aria-labelledby="button-triggers-manual" style="width: 100%;">
          <div class="dropdown-filter-part">
            <app-impact-assessment-t4-filter (OnFilterT4)="OnFilterT4($event)"></app-impact-assessment-t4-filter>
            <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
          </div>
        </div>
      </span>
      <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="cursor-pointer text-blue">
          <span class="fa fa-cog setting-icon" #dropInputsettings></span>
        </span>
        <div class="row">
          <div class="col-lg-5"></div>
          <div class="col-lg-3">
            <div id="dropdown-triggers-manual" *dropdownMenu
              class="dropdown-menu settings-dropdown-menu p-3 overflow-auto" role="menu"
              aria-labelledby="button-triggers-manual" style="width: 230px;">
              <div class="dropdown-filter-part pt-2">
                <div class="item-active" *ngFor="let item of itemActiveModelT4">
                  <input type="checkbox"
                    (change)="showHideColumnT4(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                    [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                  <span class="ml-2">{{ item.itemTitle }}</span>
                </div>
                <button class="fa fa-times cross-button filter-close-button" type="button"
                  (click)="dropInputsettings.click()"></button>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
  <div class="table-responsive box-shadow table-cont" #tableContent>
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
    <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
    <table class="table table-fixed mb-0 policy-table">
      <thead>
        <tr>
          <th class="text-center width-1pr">
            <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event, this.impactAssessmentT4Summary)" />
          </th>
          <th class="width-3pr text-center" (click)="sortImpactAssessmentT4('updatedDB_Id')">Id
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'updatedDB_Id' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'updatedDB_Id' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT4Columns.regulator"
            (click)="sortImpactAssessmentT4('Regulator')">Regulator
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'Regulator' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'Regulator' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT4Columns.title"
            (click)="sortImpactAssessmentT4('Title')">Title
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'Title' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'Title' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT4Columns.ruleTopic"
            (click)="sortImpactAssessmentT4('RuleTopic')">Topic
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'RuleTopic' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'RuleTopic' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT4Columns.publishDate"
            (click)="sortImpactAssessmentT4('updatedDB_Date')">Publish Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'updatedDB_Date' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'updatedDB_Date' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT4Columns.ruleType"
            (click)="sortImpactAssessmentT4('RuleType')">Rule Type
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'RuleType' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'RuleType' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT4Columns.applicationDate"
            (click)="sortImpactAssessmentT4('ApplicationDate')">Effective Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'ApplicationDate' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'ApplicationDate' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT4Columns.lastUpdate"
            (click)="sortImpactAssessmentT4('LastUpdate')">Last Update
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'LastUpdate' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'LastUpdate' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT4Columns.jurisdiction"
            (click)="sortImpactAssessmentT4('Jurisdiction')">Division
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'Jurisdiction' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'Jurisdiction' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT4Columns.assessor"
            (click)="sortImpactAssessmentT4('Assessor')">Assessor
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'Assessor' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'Assessor' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT4Columns.assessmentStatus"
            (click)="sortImpactAssessmentT4('AssessmentStatus')">Assessment Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT4Filter.SortKey === 'AssessmentStatus' && !impactAssessmentT4Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT4Filter.SortKey === 'AssessmentStatus' && impactAssessmentT4Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="impactAssessmentT4Summary.length === 0">
        <tr>
          <td>No Data</td>
        </tr>
      </tbody>
      <tbody *ngIf="(impactAssessmentT4Summary && (impactAssessmentT4Summary.length > 0))"
        [style.max-height.px]="myInnerHeight">
        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
          (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
          *ngIf="impactAssessmentT4Summary.length > 0">
          <div *cdkVirtualFor="let item of impactAssessmentT4Summary; let i = index">
            <tr
              [ngClass]="{'d-highlight': item.id === newIAItemId, 'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
              (click)="selectedItemId = item.id">
              <td class="width-1pr text-center" scope="row">
                <i class="fa fa-square-o icon-font" (click)="selectItem('Checked', item.id, item.updatedDBId, item.jurisdiction)"
                  *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectItem('UnChecked', item.id, item.updatedDBId, item.jurisdiction)"
                  *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
              </td>
              <td class="width-3pr text-center tabel-td-scroll" scope="row">
                <span *ngIf="item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">
                    <div *ngFor="let option of item.merged_Id|stringToArrayParent;">{{option}}</div>
                  </a>
                </span>
                <span *ngIf="!item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">{{item.updatedDBId}}</a>
                </span>

              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.regulator" scope="row">
                {{item.regulator}}</td>
              <td class="width-8pr tabel-td-scroll" *ngIf="impactAssessmentT4Columns.title" scope="row">{{item.title}}
              </td>
              <td class="width-8pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.ruleTopic" scope="row">
                <!-- <span *ngFor="let ruleItem of item.ruleTopic|jsonStringToArray; let j = index">
                  <span *ngIf="j>0 && ruleItem[1]!=''">,</span>
                  {{ruleItem[1]}}
                </span> -->
                {{item.ruleTopic}}
              </td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.publishDate" scope="row">
                {{item.publishDate | date:'dd-MMM-yyyy'}}
              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.ruleType" scope="row">
                {{item.ruleType}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.applicationDate"
                scope="row">{{item.applicationDate | date:'dd-MMM-yyyy'}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.lastUpdate" scope="row">
                {{item.lastUpdate | date:'dd-MMM-yyyy'}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.jurisdiction"
                scope="row">{{item.jurisdiction}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.assessor" scope="row">
                {{item.assessor}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT4Columns.assessmentStatus"
                scope="row">{{item.assessmentStatus}}</td>
              <td class="width-3pr text-center tabel-td-scroll">
                <a [routerLink]="['/impact-assessment/details/impact/', item.id, templateNo]">View</a> |
                <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                  <a (click)="duplicateImpactAssessmentT4(item.id)">Copy</a>
                </span>
                <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                  <span *ngIf="checkIAUserAuth(item)">
                    <a (click)="duplicateImpactAssessmentT4(item.id)">Copy</a>
                  </span>
                  <span class="disabled" *ngIf="!checkIAUserAuth(item)">Copy</span>
                </span>
              </td>
            </tr>
          </div>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>

<!-- Template 5 Design -->
<div class="row p-3" *ngIf="templateNo == 5">
  <div class="col-md-3 text-left p-0">
    <div class="text-blue" *ngIf="(impactAssessmentT5Summary && (impactAssessmentT5Summary.length>0))">
      <div>{{endIndex}} out of {{totalCount}}</div>
    </div>
  </div>
  <div class="col-md-9">
    <div class="pull-right" style="right: 20px;">
      <span *ngIf="commonService.checkPlanTypeAction(dCode)">
        <span *ngIf="currentUserRole === 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red" (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
        <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
          <span class="cursor-pointer fg-red"
            *ngIf="(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)"
            (click)="deleteItem()"><span class="fa fa-trash"></span>
            Delete
          </span>
          <span class="disabled"
            *ngIf="!(authenticatedItems.length > 0 && authenticatedItems.length === selectedItems.length)">
            <span class="fa fa-trash"></span>
            Delete
          </span>
        </span>
      </span>
      <span class="cursor-pointer text-blue pl-3" (click)="bulkUpdate()"
        *ngIf="commonService.checkPlanTypeAction(buCode)">
        Bulk Update
      </span>
      <span class="cursor-pointer text-blue pl-3" *ngIf="commonService.checkPlanTypeAction(erCode)"
        (click)="downloadReportT5()"><span class="fa fa-download"></span>
        Export Report
      </span>
      <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
          Filters <span class="caret" #dropInput></span>
        </span>
        <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu impact-assessment-filterDropdown p-3"
          role="menu" aria-labelledby="button-triggers-manual" style="width: 100%;">
          <div class="dropdown-filter-part">
            <app-impact-assessment-t5-filter (OnFilterT5)="OnFilterT5($event)"></app-impact-assessment-t5-filter>
            <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
          </div>
        </div>
      </span>
      <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="cursor-pointer text-blue">
          <span class="fa fa-cog setting-icon" #dropInputsettings></span>
        </span>
        <div class="row">
          <div class="col-lg-5"></div>
          <div class="col-lg-3">
            <div id="dropdown-triggers-manual" *dropdownMenu
              class="dropdown-menu settings-dropdown-menu p-3 overflow-auto" role="menu"
              aria-labelledby="button-triggers-manual" style="width: 230px;">
              <div class="dropdown-filter-part pt-2">
                <div class="item-active" *ngFor="let item of itemActiveModelT5">
                  <input type="checkbox"
                    (change)="showHideColumnT5(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                    [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                  <span class="ml-2">{{ item.itemTitle }}</span>
                </div>
                <button class="fa fa-times cross-button filter-close-button" type="button"
                  (click)="dropInputsettings.click()"></button>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
  <div class="table-responsive box-shadow table-cont body-style5" #tableContent>
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <span class="fa fa-arrow-left text-muted arrows arrow-left" (click)="scrollLeft()"></span>
    <span class="fa fa-arrow-right text-muted arrows arrow-right" (click)="scrollRight()"></span>
    <table class="table table-fixed mb-0 policy-table">
      <thead>
        <tr>
          <th class="text-center width-1pr">
            <input type="checkbox" [checked]="selectedItems.length > 0 ? 'checked' : ''" (change)="allSelectedItems($event, this.impactAssessmentT5Summary)" />
          </th>
          <th class="width-3pr text-center" (click)="sortImpactAssessmentT5('updatedDB_Id')">Id
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'updatedDB_Id' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'updatedDB_Id' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT5Columns.regulator"
            (click)="sortImpactAssessmentT5('Regulator')">Regulator
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'Regulator' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'Regulator' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT5Columns.title"
            (click)="sortImpactAssessmentT5('Title')">Title
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'Title' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'Title' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-8pr text-center" *ngIf="impactAssessmentT5Columns.ruleTopic"
            (click)="sortImpactAssessmentT5('RuleTopic')">Topic
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'RuleTopic' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'RuleTopic' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.team"
            (click)="sortImpactAssessmentT5('Team')">Team
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'Team' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'Team' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT5Columns.ruleType"
            (click)="sortImpactAssessmentT5('RuleType')">Rule Type
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'RuleType' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'RuleType' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT5Columns.effectiveDate"
            (click)="sortImpactAssessmentT5('EffectiveDate')">Effective Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'EffectiveDate' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'EffectiveDate' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT5Columns.responseLead"
            (click)="sortImpactAssessmentT5('ResponseLead')">Response Lead
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ResponseLead' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ResponseLead' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT5Columns.jurisdiction"
            (click)="sortImpactAssessmentT5('Jurisdiction')">Division
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'Jurisdiction' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'Jurisdiction' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT5Columns.accountableExecutive"
            (click)="sortImpactAssessmentT5('AccountableExecutive')">Accountable Executive
            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'AccountableExecutive' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'AccountableExecutive' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT5Columns.rAGRating"
            (click)="sortImpactAssessmentT5('RAGRating')">RAG Rating
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'RAGRating' && !impactAssessmentT5Filter.IsDesc),
          'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'RAGRating' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.resposeDeadline"
            (click)="sortImpactAssessmentT5('ResposeDeadline')">Response Deadline
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ResposeDeadline' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ResposeDeadline' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.consultationPeriod"
            (click)="sortImpactAssessmentT5('ConsultationPeriod')">Consultation Period
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ConsultationPeriod' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ConsultationPeriod' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center" *ngIf="impactAssessmentT5Columns.didWeRespond"
            (click)="sortImpactAssessmentT5('DidWeRespond')">Did We Respond
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'DidWeRespond' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'DidWeRespond' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.responseAppraoch"
            (click)="sortImpactAssessmentT5('ResponseAppraoch')">Response Approach
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ResponseAppraoch' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ResponseAppraoch' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.reportSubmissionDate"
            (click)="sortImpactAssessmentT5('ResponseSubmissionDate')">Report Submission Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ResponseSubmissionDate' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ResponseSubmissionDate' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.extensionRequested"
            (click)="sortImpactAssessmentT5('ExtensionRequested')">Extension Requested
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'ExtensionRequested' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'ExtensionRequested' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.currentStatus"
            (click)="sortImpactAssessmentT5('CurrentStatus')">Current Status
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'CurrentStatus' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'CurrentStatus' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.nextActionDate"
            (click)="sortImpactAssessmentT5('NextActionDate')">Next Action Date
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'NextActionDate' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'NextActionDate' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.engagementPlan"
            (click)="sortImpactAssessmentT5('EngagementPlan')">Engagement Plan
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'EngagementPlan' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'EngagementPlan' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-5pr text-center" *ngIf="impactAssessmentT5Columns.policyResponseAchieved"
            (click)="sortImpactAssessmentT5('PolicyResponseAchieved')">Policy Response Achieved
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'PolicyResponseAchieved' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'PolicyResponseAchieved' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.numberofKeyMessages"
            (click)="sortImpactAssessmentT5('NumberofKeyMessages')">Number of Key Messages
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'NumberofKeyMessages' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'NumberofKeyMessages' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-4pr text-center" *ngIf="impactAssessmentT5Columns.keyMessagesAcheived"
            (click)="sortImpactAssessmentT5('KeyMessagesAcheived')">Key Messages Acheived
            <i class="fa"
              [ngClass]="{'fa-sort-amount-asc': (impactAssessmentT5Filter.SortKey === 'KeyMessagesAcheived' && !impactAssessmentT5Filter.IsDesc),
              'fa-sort-amount-desc': (impactAssessmentT5Filter.SortKey === 'KeyMessagesAcheived' && impactAssessmentT5Filter.IsDesc) }"
              aria-hidden="true">
            </i>
          </th>
          <th class="width-3pr text-center">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="impactAssessmentT5Summary.length === 0">
        <tr>
          <td>No Data</td>
        </tr>
      </tbody>
      <tbody *ngIf="(impactAssessmentT5Summary && (impactAssessmentT5Summary.length > 0))"
        [style.max-height.px]="myInnerHeight">
        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
          (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
          *ngIf="impactAssessmentT5Summary.length > 0">
          <div *cdkVirtualFor="let item of impactAssessmentT5Summary; let i = index">
            <tr
              [ngClass]="{'d-highlight': item.id === newIAItemId, 'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
              (click)="selectedItemId = item.id">
              <td class="width-1pr text-center" scope="row">
                <i class="fa fa-square-o icon-font" (click)="selectItem('Checked', item.id, item.updatedDB_Id, item.jurisdiction)"
                  *ngIf="!_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectItem('UnChecked', item.id, item.updatedDB_Id, item.jurisdiction)"
                  *ngIf="_globalService.getSelectedItems(item.id, selectedItems)" aria-hidden="true"></i>
              </td>
              <td class="width-3pr text-center tabel-td-scroll" scope="row">
                <span *ngIf="item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">
                    <div *ngFor="let option of item.merged_Id|stringToArrayParent;">{{option}}</div>
                  </a>
                </span>
                <span *ngIf="!item.isMerged">
                  <a  (click)="redirectLink(templateNo,item.id)">{{item.updatedDB_Id}}</a>
                </span>

              </td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.regulator" scope="row">{{item.regulator}}</td>
              <td class="width-8pr tabel-td-scroll" *ngIf="impactAssessmentT5Columns.title" scope="row">{{item.title}}</td>
              <td class="width-8pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.ruleTopic" scope="row">{{item.ruleTopic}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.team" scope="row">{{item.team}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.ruleType" scope="row">{{item.ruleType}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.effectiveDate" scope="row">{{item.effectiveDate | date:'dd-MMM-yyyy'}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.responseLead" scope="row">{{item.responseLead}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.jurisdiction" scope="row">{{item.jurisdiction}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.accountableExecutive" scope="row">{{item.accountableExecutive}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.rAGRating" scope="row">{{item.ragRating}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.resposeDeadline"scope="row">{{item.resposeDeadline | date:'dd-MMM-yyyy'}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.consultationPeriod" scope="row">{{item.consultationPeriod}}</td>
              <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.didWeRespond" scope="row" > {{ item.didWeRespond ? 'Yes' : 'No' }}</td>
              <!-- <td class="width-3pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.didWeRespond" scope="row" >{{item.didWeRespond}}</td> -->
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.responseAppraoch" scope="row">{{item.responseAppraoch}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.reportSubmissionDate"scope="row">{{item.reportSubmissionDate | date:'dd-MMM-yyyy'}}</td>
              <!-- <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.extensionRequested" scope="row">{{item.extensionRequested}}</td> -->
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.extensionRequested" scope="row">{{ item.extensionRequested ? 'Yes' : 'No' }}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.currentStatus" scope="row">{{item.currentStatus}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.nextActionDate"scope="row">{{item.nextActionDate | date:'dd-MMM-yyyy'}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.engagementPlan" scope="row">{{item.engagementPlan}}</td>
              <td class="width-5pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.policyResponseAchieved" scope="row">{{item.policyResponseAchieved}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.numberofKeyMessages" scope="row">{{item.numberofKeyMessages}}</td>
              <td class="width-4pr text-center tabel-td-scroll" *ngIf="impactAssessmentT5Columns.keyMessagesAcheived" scope="row">{{item.keyMessagesAcheived}}</td>
              <td class="width-3pr text-center tabel-td-scroll">
                <a [routerLink]="['/impact-assessment/details/impact/',templateNo, item.id]">View</a> |
                <span *ngIf="currentUserRole === 'Compliance Enterprise'">
                  <a (click)="duplicateImpactAssessmentT5(item.id)">Copy</a>
                </span>
                <span *ngIf="currentUserRole !== 'Compliance Enterprise'">
                  <span *ngIf="checkIAT5UserAuth(item)">
                    <a (click)="duplicateImpactAssessmentT5(item.id)">Copy</a>

                  </span>
                  <span class="disabled" *ngIf="!checkIAT5UserAuth(item)">Copy</span>
                </span>
              </td>
            </tr>
          </div>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
